module.exports = __webpack_public_path__ + "img/search-plus.9e9af8ca.svg";